import { Routes } from '@angular/router';

export const LOGIN_ROUTES: Routes = [
	{
		path: 'login',
		loadComponent: () => import('./feature-login/login').then((m) => m.Login),
	},
];
